import styles from './Chamado.module.css'
// import {MdAttachFile} from 'react-icons/md'
// import {IoDocumentAttachOutline} from 'react-icons/io'
// import {BsReplyFill} from 'react-icons/bs'
import {useParams, Link} from 'react-router-dom'
import {useState, useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom';
import {FiArrowLeft} from 'react-icons/fi'

import Loading from '../layout/Loading'
import Container from '../layout/Container'
import ChamadoForm from '../project/ChamadoForm'
import PrioridadeCard from '../project/PrioridadeCard'
import SituacaoBadge from '../project/SituacaoBadge'
import Mensagem from '../project/Mensagem'
import {FiCheckCircle} from 'react-icons/fi'

import {__URL } from '../../config'
import ReplyForm from '../project/ReplyForm'

import { ToastContainer, toast } from 'react-toastify';


function Chamado() {
    const {id} = useParams()
    const navigate = useNavigate()

    const [userSession] = useState(JSON.parse(localStorage.getItem('userSession')))
    const [setRemoveLoading] = useState(false)

    const [chamado, setChamado] = useState([])
     //const [mensagem, setMensagem] = useState([])
    const [debounce, setDebounce] = useState(true)
    const [showChamadoForm, setShowChamadoForm] = useState(false)
    // const [setMensagemForm, setShowMensagemForm] = useState (false)
    const formRef = useRef(null)

    const handleSave = () => {
    if (formRef.current) {
        const isValid = formRef.current.validateForm();
        if (isValid) {
            formRef.current.submitForm();
        }
    }
    };

    const fetchChamado = () => {
        fetch( __URL + `/chamado/admin/${id}`, {
           method : "GET",
           headers: {
               'Content-Type': 'application/json',
               'Authorization': `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
           },
       })
       .then((resp) => {
           if (resp.status === 200)
               return resp.json()
           return false
       })
       .then((data) => {
           console.log('Chamado.js - fetchChamado' , data)
           if(data !== false) {
               setChamado(data.data)
               setRemoveLoading(true)
           }
       }).catch((err) => {
           console.log('Chamado.js - error',err)
       })
    }

    useEffect(() => {
        if (!chamado.hasOwnProperty('ID')) {
            fetchChamado()
        }
    }, [id, userSession, chamado, setRemoveLoading ])

    useEffect(() => {
        if (chamado.ID) {
            document.title = `#${chamado.ID} - J & O Chamados`
        }
        return () => {
            document.title = 'J&O Chamados'
        }
    }, [chamado.ID])

    function toggleChamadoForm() {
        setShowChamadoForm(!showChamadoForm)
    }

    function editMotivos(formResponse) {

        console.log('Chamado.js - editMotivos',formResponse.usuarios)

        const buildFormData = (usuarios) => {
            let data = new FormData();
            formResponse.motivos.map((mtv, indice) => {
                data.append(`motivos[${indice}]`, mtv);
                return mtv;
            })

            usuarios.map((usr, indice) => {
                data.append(`usuarios[${indice}]`, usr);
                return usr;
            })
            data.append('chm_prioridade_interna', formResponse.prioridadeInterna)
            // vazio limpa a situação
            data.append('chm_situacao', formResponse.situacao || '')
            return data;
        }

        const updateChamado = (usuarios) => {
            return fetch( __URL + `/chamado/${formResponse.chamado.ID}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
                },
                body: buildFormData(usuarios)
            }).then((resp) => resp.json());
        }

        const responsaveisAtuais = chamado.USUARIOS
            ? chamado.USUARIOS.filter((usrFilter) => {return parseInt(usrFilter.ATRIBUICAO) === 3})
            : [];
        const removeParcial = responsaveisAtuais.length > formResponse.usuarios.length
            && formResponse.usuarios.length > 0;

        const salvar = removeParcial
            ? updateChamado([]).then(() => updateChamado(formResponse.usuarios))
            : updateChamado(formResponse.usuarios);

        return salvar
            .then((data) => {
                if (data?.data?.CHAMADO) {
                    setChamado({ ...chamado, 'MOTIVOS': data.data.CHAMADO.MOTIVOS,
                                             'PRIORIDADE_INTERNA': data.data.CHAMADO.chm_prioridade_interna,
                                             'TP_SITUACAO': formResponse.situacao || null,
                                             'USUARIOS' : data.data.RESPONSAVEIS })
                }
                fetchChamado()
                setShowChamadoForm(false)
                return data
            })
            .catch((err) => {
                console.log('Chamado.js - editMotivos - error', err)
                throw err
            })
    }

    function replyPost(formResponse) {
        let data = (formResponse)

        if ( debounce ) {
            setDebounce(false)
            fetch ( __URL + `/mensagem`, {
                method: 'POST',
                headers: {
                    'Authorization' : `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
                },
                body: data
            })
            .then((resp) => {
                if (resp.status === 200)
                        return resp.json()
                return false
            })
            .then((data) => {
                navigate(`/chamados`, {state:{message : 'Respondido com sucesso!'}});
                //window.location.href = `/chamado/${id}`;
                //TODO Rever para padrão REACT, modificar API
                //navigate(``, {state:{message : 'Respondido com sucesso!'}} )
                return true;

            })
            .catch((err) => {
                setDebounce(true)
                console.log('Chamado.js - replyPost - error', err)
            })
        } else {
            toast.warn("Já existe uma requisição em andamento, aguarde!", {
                theme: "colored"
            })
        }
    }

    function reOpenPost() {

        let formData = new FormData();

        if ( debounce ) {
            setDebounce(false)
            formData.append('id_chamado', chamado.ID)
            formData.append('chm_encerrar', 'R')
            fetch ( __URL + `/mensagem`, {
                method: 'POST',
                headers: {
                    'Authorization' : `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
                },
                body: formData
            })
            .then((resp) => {
                if (resp.status === 200)
                        return resp.json()
                return false
            })
            .then((data) => {
                navigate(`/chamados`, {state:{message :  'Chamado reaberto com sucesso!'}});
                return true;
            })
            .catch((err) => {
                setDebounce(true)
                console.log('Chamado.js - reOpenPost - error', err)
            })
        } else {
            toast.warn("Já existe uma requisição em andamento, aguarde!",{theme: "colored"})
        }

    }

    let responsaveis = []
    if ( chamado.ID )
        responsaveis = chamado.USUARIOS.filter((usrFilter) => {return parseInt(usrFilter.ATRIBUICAO) === 3}); 
        console.log('Chamado.js - if - responsaveis', responsaveis)

    return (<>
        {chamado.ID ? (
            <div className={styles.chamadoDetails}>
                <Container customClass="column">
                    <Link to="/chamados" className={styles.backLink}><FiArrowLeft /> Voltar para Chamados</Link>
                    <div className={styles.topDivider}></div>
                    <div className={styles.detailsContainer}>
                        <div className={styles.headerRow}>
                            <div className={styles.detailsHeader}>
                                <h1>Chamado #{chamado.ID}</h1>
                                {chamado.PRIORIDADE_INTERNA ?
                                ( <PrioridadeCard prioridade={chamado.PRIORIDADE_INTERNA}/>)
                                :
                                (
                                <p className={styles.noprior}>Sem prioridade definida</p>)}
                            </div>
                            {chamado.DT_FINALIZACAO ?
                            (<button type='button' className={styles.btn} onClick={reOpenPost}>Reabrir Chamado</button>)
                            :
                            (
                            <div className={styles.btnContainer}>
                                {showChamadoForm && (
                                    <button
                                        type='button'
                                        className={styles.btn}
                                        onClick={(() => {
                                            if(formRef.current){
                                                formRef.current.submitForm();
                                            }
                                        })}
                                    >Salvar</button>
                                )}
                                <button type='button' className={styles.btn} onClick={toggleChamadoForm}>
                                    {!showChamadoForm ? 'Gerenciar Chamado' : 'Fechar'}
                                </button>
                            </div>
                            )}
                        </div>

                        {!showChamadoForm ? (
                            <div className={styles.chamadoInfo}>
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Data de Abertura</span>
                                    <span className={styles.infoValue}>{chamado.DT_ABERTURA} <span className={styles.infoMuted}>({chamado.CD_USUARIO_AUTOR})</span></span>
                                </div>
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Data Última Atividade</span>
                                    <span className={styles.infoValue}>{chamado.DT_ULTIMA_ATIVIDADE} {chamado.CD_USUARIO_ULTIMA_ATV && <span className={styles.infoMuted}>({chamado.CD_USUARIO_ULTIMA_ATV})</span>}</span>
                                </div>
                                {chamado.DT_FINALIZACAO && (
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Data Finalização</span>
                                    <span className={styles.infoValue}>{chamado.DT_FINALIZACAO} <span className={styles.infoMuted}>({chamado.CD_USUARIO_FINALIZACAO})</span></span>
                                </div>
                                )}
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Situação</span>
                                    <span className={styles.infoValue}>{chamado.TP_SITUACAO ? <SituacaoBadge situacao={chamado.TP_SITUACAO} /> : 'NENHUMA'}</span>
                                </div>
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Módulo</span>
                                    <span className={styles.infoValue}>{chamado.TX_MODULO}</span>
                                </div>
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>TAGs</span>
                                    <span className={styles.infoValue}>{chamado.MOTIVOS.length > 0 ? chamado.MOTIVOS.map((mtv) => {return mtv.TX_MOTIVO}).join(', ') : 'NENHUM'}</span>
                                </div>
                                <div className={styles.infoField}>
                                    <span className={styles.infoLabel}>Responsáveis</span>
                                    <span className={styles.infoValue}>{responsaveis.length > 0 ? responsaveis.map((usr) => {return usr.CD_USUARIO}).join(', ') : 'NENHUM'}</span>
                                </div>
                            </div>
                              ) : (
                                <div className={styles.chamadoInfo}>
                                    <ChamadoForm
                                    ref={formRef}
                                    handleSubmit={editMotivos}
                                    btnText="Atualizar Chamado"
                                    chamadoData={chamado}
                                    isEditing={true}
                                    />
                                </div>
                            )}
                    </div>

                    <h2>Mensagens</h2>
                    <Container customClass="start">
                        {chamado.MENSAGENS.length > 0 &&
                        <div className={styles.chamadoGroupsMessages}>
                            {chamado.MENSAGENS.map((msg) => {
                                return <Mensagem msg={msg} />
                            })}
                        </div>
                        }
                        {(chamado.DT_FINALIZACAO ?
                            <Container>
                                <div className={styles.chamadoFinalizadoTitle}>
                                    <div className={styles.chamadoFinalizadoContent}>
                                        <p><FiCheckCircle /> Este chamado foi encerrado por {chamado.CD_USUARIO_FINALIZACAO} em {chamado.DT_FINALIZACAO}.</p>
                                    </div>
                                    <div className={styles.chamadoFinalizadoButton}></div>
                                </div>
                            </Container> : <ReplyForm handleSubmit={replyPost} chamado={chamado} btnText="Enviar" /> )}
                    </Container>
                 </Container>
                <ToastContainer />
            </div>
        ) :<Loading />}
    </>)
}

export default Chamado
